import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getSectionsDetail } from '../../api/home'
import { sendSetAppsflyerEvent } from '../../js/postMessage'

import { FlatCategory } from '@shopby/shop-sdk'
import { PropsType } from '../../@types/etc'
import { SectionDetailType } from '../../@types/home'
import { AllCategoryFlatCategory } from '../../@types/product'
import { findObjectsWithValue } from '../../js/script'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import { BrandThemeItem } from './BrandThemeItem'

export default function BrandTheme({ el, index, homeModule, category }: PropsType) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>() //섹션 아이템 정보
  const [productCategory, setProductCategory] = useState<number[]>([]) //상품 카테고리
  const [isModal, setIsModal] = useState<boolean>(false) //모달 체크
  const [selectProductNo, setSelectProductNo] = useState<string>('') //선택한 상품 번호
  const [like, setLike] = useState<boolean>(false) //좋아요 했을떄 상품 다시 불러오기
  const [categories, setCategories] = useState<AllCategoryFlatCategory[]>([]) //카테고리 정보
  const [brandCategorys, setBrandCategorys] = useState<FlatCategory[]>([]) //브랜드 하위 카테고리 정보
  const { isAppView } = useAppContext()

  //상품진열 상세 가져오기
  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        // 첫 번째 제품의 displayCategoryNos를 평탄화하여 배열 생성
        const productCategory = res.data.flatMap(
          (el: { products: { displayCategoryNos: string }[] }) => el.products[0]?.displayCategoryNos.split('|') || []
        )

        // 상태 설정
        setProductCategory(productCategory)
        setSectionItem(res.data[0]) // 첫 번째 섹션 아이템 설정
      })
      .catch((err) => console.log(err))
  }, [el.sectionNo, like])
  // 브랜드만 가져오기
  useEffect(() => {
    if (category) {
      const brandCategories: FlatCategory[] | undefined = category.flatCategories?.filter(
        (element: any) => element.depth1Label === '브랜드'
      )

      if (brandCategories) {
        setBrandCategorys(brandCategories)
      }
    }
  }, [category])
  //value로 해당 되는 카테고리 찾기
  useEffect(() => {
    if (brandCategorys.length > 0 && productCategory.length > 0) {
      // findObjectsWithValue를 호출하여 평탄화된 배열 생성
      const categoryArray: AllCategoryFlatCategory[] = productCategory.flatMap((el: any): any =>
        findObjectsWithValue(brandCategorys, el)
      )
      setCategories(categoryArray)
    }
  }, [brandCategorys, productCategory])

  return (
    <>
      <div
        className='brand_items'
        style={{ minHeight: isMobile ? '420px' : '588px' }}
        onClick={(): void => {
          const gtmNavigateClick: DataLayerArgs = {
            dataLayer: {
              event: 'select_content',
              event_info: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            },
          }
          if (isAppView) {
            sendSetAppsflyerEvent({
              eventName: 'select_content',
              eventType: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            })
          } else {
            TagManager.dataLayer(gtmNavigateClick)
          }
        }}
      >
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain}</strong>
          </p>
        </div>
        <Swiper
          spaceBetween={8}
          slidesPerView={2.4391}
          breakpoints={{
            768: {
              spaceBetween: 16,
              slidesPerView: 5,
            },
          }}
        >
          {sectionItem?.products?.map((element: any, idx: number) => {
            return (
              <SwiperSlide key={`${element.productNo}-${idx}-${index}`}>
                <BrandThemeItem
                  el={element}
                  idx={idx}
                  setIsModal={setIsModal}
                  setSelectProductNo={setSelectProductNo}
                  setLike={setLike}
                  listId={el.sectionNo}
                  listName={el.sectionName}
                  categories={categories}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
        {/* <div className='btn_more_wrap'>
        <BtnHomeModuleMore
          onClick={(): void => {
            setPrevScroll(document.documentElement.scrollTop);
            navigate(
              `/category/${brandCategory}/${brandCategory}/${brandCategory}`
            );
          }}
        >
          더보기
        </BtnHomeModuleMore>
      </div> */}
        {index !== 0 && <hr />}
      </div>
      {isModal &&
        (isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={sectionItem?.products}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={sectionItem?.products}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductCenterModal>
        ))}
    </>
  )
}
